import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { TableSpinner } from "../../../components";
import { useGetCourseSelectListQuery } from "../../../store/api/courseApi";
import {
  buildSubjectsSearch,
  getCourseIdBySlug,
} from "../../../utils/subjectsNavigation";

export const PlansLegacyRedirect = () => {
  const history = useHistory();
  const { course } = useParams<{ course: string }>();
  const { data: courses } = useGetCourseSelectListQuery();

  useEffect(() => {
    if (!courses?.length || !course) return;

    const courseId = getCourseIdBySlug(courses, course);
    const search = buildSubjectsSearch({ courseId });
    history.replace(`/payment/plans${search}`);
  }, [courses, course, history]);

  return <TableSpinner />;
};
